import {createStrokeSVG} from './TEMPLATE'

// iconoir: sort-down
export const FilterTimeline_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M14 10L2 10',
    'M10 14H2',
    'M6 18H2',
    'M18 6L2 6',
    'M19 10V20M19 20L22 17M19 20L16 17',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})
